const sizeSelect = document.querySelector('.js-select-size');

const switchSizeAddToCart = function () {
  $('.add-to-cart-actions').on('product:updateAddToCart', function (e, response) {
    const switchToAddToCart = response.product.readyToOrder;
    document.querySelector('.add-to-cart-switch').classList.toggle('-active', switchToAddToCart);
    document.querySelector('.size-switch').classList.toggle('-active', !switchToAddToCart);
    document.querySelector('.add-to-cart-error-messaging').classList.add('d-none');
  });
}

const shortTextHandling = function(){
  const sizeContainer = document.querySelector('.attribute-size');
  const sizeSelect = sizeContainer.querySelector('.js-select-size');
  const fakePlaceholder = document.createElement("span");
  fakePlaceholder.classList.add('fake-placeholder');
  fakePlaceholder.setAttribute('aria-hidden', true);
  sizeContainer.prepend(fakePlaceholder);
  document.querySelector('.js-select-size').addEventListener('change', (e) => {
    const shortText =  e.target.options[e.target.selectedIndex].dataset.shortText;
    sizeContainer.classList.toggle('with-short-text', shortText !== undefined ? true : false);
    if (shortText) {
      fakePlaceholder.innerHTML = shortText;
    }
  });
}


const notifyChangeFocus = function () {
  if(document.querySelector('.js-notify-me-button')){
    document.querySelector('.js-notify-me-button').addEventListener('click',(e)=>{
      sizeSelect.focus();
    });
  }
}

const bindEvents = function(){
  switchSizeAddToCart();
  sizeSelect && shortTextHandling();
  notifyChangeFocus();
}

module.exports = {
  bindEvents: bindEvents
}